<template>
    <div>
        <h3 class="font-semibold text-xl mb-4">{{ $t("uploadDocuments") }}</h3>
        <p class="text-sm mb-4">{{ $t("uploadDocumentsDesc") }}</p>
        <div class="mt-6">
            <vue-dropzone
                style="max-width: 400px; padding: 10px;"
                :options="{...dropzoneOptions, ...{acceptedFiles: '.jpg,.jpeg,.png,.gif,.tiff,.pdf'}}"
                @vdropzone-success="addressFileUploaded"
                @vdropzone-removed-file="addressFileRemoved"
                :useCustomSlot=true
                id="addressFile"
            >
                <div>
                    <div class="font-bold text-primary-500">{{ $t("proofOfAddress") }}</div>
                    <div class="mt-3 text-sm text-gray-500">{{ $t("dragAndDrop") }}</div>
                    <div class="mt-3 text-sm text-gray-700" v-html="$t('proofOfAddressDesc')">
                    </div>
                </div>
            </vue-dropzone>
            <div v-if="fieldError('addressFileReference')"
                 class="text-red-500 text-xs italic">
                {{ fieldError('addressFileReference') }}
            </div>
        </div>



        <div class="mt-6">
            <k-button @click.native.prevent="onSubmit" :disabled="submitDisabled">
                {{ $t("submit") }}
            </k-button>
        </div>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    components: {
        vueDropzone: vue2Dropzone
    },
    props: {
        validation: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: {
                addressFileReference: null,
            },
            dropzoneOptions: {
                url: '/api/guest/upload',
                thumbnailWidth: null,
                thumbnailHeight: 200,
                maxFiles: 1,
                maxFilesize: 25,
                addRemoveLinks: true,
                createImageThumbnails: true,
                acceptedFiles: '.jpg,.jpeg,.png,.gif,.tiff',
                init: function () {
                    this.on('addedfile', function () {
                         if (this.files.length > 1) {
                             this.removeFile(this.files[0]);
                         }
                    });
                },
            }
        }
    },
    computed: {
        submitDisabled() {
            return !this.form.addressFileReference
        }
    },
    methods: {
        async onSubmit() {
            this.$emit('submit', this.form);
        },
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
        addressFileUploaded(file, response) {
            this.form.addressFileReference = response.fileReference;
        },
        addressFileRemoved() {
            this.form.addressFileReference = null;
        }
    }
}
</script>

